import React from "react";
import { FormSendListDesktop } from "./form.desktop";
import { FormSendListMobile } from "./form.mobile";
import { LayoutStyleTypes, LayoutTypes, useLayoutType } from "@/util-react/layout";

const getPageComponent = (layoutStyleType: string) => {
  switch (layoutStyleType) {
    case LayoutStyleTypes.TYPE_XXS:
    case LayoutStyleTypes.TYPE_XS:
    case LayoutStyleTypes.TYPE_SM:
    case LayoutStyleTypes.TYPE_MD:
    case LayoutStyleTypes.TYPE_LG:
    case LayoutStyleTypes.TYPE_XL:
      return FormSendListMobile;
    case LayoutStyleTypes.TYPE_XXL:
      return FormSendListDesktop;
    case LayoutTypes.TYPE_MOBILE:
  }
};

export const FormSendList: React.FC = () => {
  const { layoutStyleType } = useLayoutType();
  const PageComponent = getPageComponent(layoutStyleType);

  return <PageComponent />;
};
